var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoungePoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 33.2939V37.4999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 33.2939V37.4999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22.5V18C36 17.2044 35.6839 16.4413 35.1213 15.8787C34.5587 15.3161 33.7956 15 33 15H15C14.2044 15 13.4413 15.3161 12.8787 15.8787C12.3161 16.4413 12 17.2044 12 18V22.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 28.5H18C17.2044 28.5 16.4413 28.1839 15.8787 27.6213C15.3161 27.0587 15 26.2956 15 25.5C15 24.7044 14.6839 23.9413 14.1213 23.3787C13.5587 22.8161 12.7956 22.5 12 22.5C11.2044 22.5 10.4413 22.8161 9.87868 23.3787C9.31607 23.9413 9 24.7044 9 25.5C9 27.8869 9.94821 30.1761 11.636 31.864C13.3239 33.5518 15.6131 34.5 18 34.5H30C32.3869 34.5 34.6761 33.5518 36.364 31.864C38.0518 30.1761 39 27.8869 39 25.5C39 24.7044 38.6839 23.9413 38.1213 23.3787C37.5587 22.8161 36.7956 22.5 36 22.5C35.2044 22.5 34.4413 22.8161 33.8787 23.3787C33.3161 23.9413 33 24.7044 33 25.5C33 26.2956 32.6839 27.0587 32.1213 27.6213C31.5587 28.1839 30.7956 28.5 30 28.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoungePoi);
export default __webpack_public_path__ + "static/media/lounge-poi.7c7ba6789809c27584ffc2b71e2b6c14.svg";
export { ForwardRef as ReactComponent };